<template >
  <div id="RegisterState">
    <el-card v-if="companyApplyListShow == 0" >
      <template #header>
        <div class="headType">
        <span>已注册公司状态</span>
        <div class="button-group-title">
          <el-button size="mini" type="primary" @click="companyApplyListShow = 1" :plain="true">
            <i class="el-icon-circle-plus"></i>
            新注册公司
          </el-button>
        </div>
        </div>
      </template>

      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="审核通过" name="first">
          <div style="margin: 10px 15px 10px 15px;">
            <el-table :data="itemCompanyListPass" style="width: 100%;text-align: center; height: 100%; " border
                      ref="refTable"
                      :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
<!--              <el-table-column prop="id" label="公司id" width="80" show-overflow-tooltip align="center"/>-->
              <el-table-column prop="companyName" label="公司名称" min-width="220" show-overflow-tooltip align="center"/>
              <el-table-column prop="createTime" label="创建时间" min-width="220" show-overflow-tooltip align="center"/>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待审核" name="second">
          <div style="margin: 10px 15px 10px 15px;">
            <el-table :data="itemCompanyUnKonw" style="width: 100%;text-align: center; height: 100%; " border
                      ref="refTable"
                      :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
<!--              <el-table-column prop="id" label="公司id" width="80" show-overflow-tooltip align="center"/>-->
              <el-table-column prop="companyName" label="公司名称" min-width="220" show-overflow-tooltip align="center"/>
              <el-table-column prop="createTime" label="创建时间" min-width="220" show-overflow-tooltip align="center"/>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="审核失败" name="third">
          <div style="margin: 10px 15px 10px 15px;">
            <el-table :data="itemCompanyFail" style="width: 100%;text-align: center; height: 100%; " border
                      ref="refTable"
                      :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
<!--              <el-table-column prop="id" label="公司id" width="80" show-overflow-tooltip align="center"/>-->
              <el-table-column prop="companyName" label="公司名称" min-width="220" show-overflow-tooltip align="center"/>
              <el-table-column prop="createTime" label="创建时间" min-width="220" show-overflow-tooltip align="center"/>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <RegisterCompany v-if="companyApplyListShow == 1" @returnBack="returnBack"></RegisterCompany>
  </div>
</template>

<script>
import API from "../../../../../config/api";
import RegisterCompany from "@/pages/userCenter/ChildComps/RegisterCompany"

export default {
  components: {
    RegisterCompany
  },
  data() {
    return {
      activeName: 'first', //tab选中的

      itemCompanyListPass: [],  //各个状态公司的数组
      itemCompanyFail: [],
      itemCompanyUnKonw: [],
      userId: '',//登录用户
      companyApplyListShow: 0,
    }
  },
  mounted() {
    // 注册公司
    // 接口：companyRegister
    // 参数：companyName、adminId
    this.userId = window.localStorage.getItem('userid');
    console.log('注册公司userId的值=', this.userId);
    this.getCompanyList();
  },

  methods: {
    //从注册公司页面返回此页面
    returnBack(){
      this.getCompanyList();
      this.companyApplyListShow = 0;
    },
    //页面切换
    handleClick(tab) {
      console.log(tab);
      this.activeName = tab.name;
    },
    //获取公司列表
    getCompanyList() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        adminId: window.localStorage.getItem('userid'),
      }

      this.$axiosRequest({
        url: API.getCompanyApplyList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {

          console.log(res)
          let list = res.data["companyApplyList"];
          this.itemCompanyUnKonw = [];
          for (let i = 0; i < list.length; i++) {
            if (list[i].state == 0)
              this.itemCompanyUnKonw.push(list[i]);
          }
          this.itemCompanyListPass = [];
          for (let i = 0; i < list.length; i++) {
            if (list[i].state == 1)
              this.itemCompanyListPass.push(list[i]);
          }
          this.itemCompanyFail = [];
          for (let i = 0; i < list.length; i++) {
            if (list[i].state == 2)
              this.itemCompanyFail.push(list[i]);
          }
        }
      });
    },
  }
}
</script>

<style scoped lang="less">
#RegisterState{
  .button-group-title {
    margin: 0px 0px 0px 30px; // 上 右 下 左
    font-size: 18px;
    font-weight: bold;
  }
  .headType{
    display:flex;
    justify-content: left;
  }
}

</style>